import { SPECIAL_CHARACTERS_FIRST_LAST_NAME } from 'app/validators/base/constants'

export const exclusionSpecialSymbols = (value: string) =>
  value && value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\\/[{/}[\]]/gi, '')

export const exclusionSpecialSymbolsInTeamName = (value: string) =>
  value && value.replace(/[`~@$%^&*|+=?;:",<>\\[{/}[\]]/gi, '')

export const exclusionSpecialSymbolsForUserName = (value: string) =>
  value && value.replace(new RegExp(SPECIAL_CHARACTERS_FIRST_LAST_NAME, 'gi'), '')

export const excludeNonLatinSymbols = (value: string) => value && value.replace(/[^a-zA-Z0-9\s]/gi, '')

export const exchangeSpacesToSpace = (value: string) => value && value.replace(/\s{1,}/gi, ' ')

export const exclusionSpecialSymbolsAndRemoveDoubleSpaces = (value: string) =>
  value && exchangeSpacesToSpace(exclusionSpecialSymbols(value))

export const exclusionSpecialSymbolsAndRemoveDoubleSpacesInTeamName = (value: string) =>
  value && exchangeSpacesToSpace(exclusionSpecialSymbolsInTeamName(value))

export const excludeNonLatinSymbolsAndRemoveDoubleSpaces = (value: string) =>
  value && exchangeSpacesToSpace(excludeNonLatinSymbols(value))
